import { FormizoCustom, FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";
/** ---------------- Main Config Schema ----------------- */
const quickReplyControl: FormizoSchema = {
  control: "talk2va.quick_reply.enabled",
  fold: [
    {
      label: "Quick Reply Buttons",
      name: "talk2va.quick_reply.quickReplies",
      canAdd: true,
      canDelete: true,
      headerStyle: "outlined",
      addStyle: "header",
      array: [
        {
          label: "Display",
          width: 50,
          name: "title",
          tabs: [
            {
              label: "EN",
              page: [
                {
                  label: "Display",
                  name: "title.EN",
                  format: "text",
                },
              ],
            },
            {
              label: "TC",
              page: [
                {
                  label: "Display",
                  name: "title.TC",
                  format: "text",
                },
              ],
            },
            {
              label: "SC",
              page: [
                {
                  label: "Display",
                  name: "title.SC",
                  format: "text",
                },
              ],
            },
          ],
          validate: ["required"],
        },
        {
          label: "Button Type",
          name: "type",
          format: "select",
          width: "100",
          options: [
            { label: "FAQ/Context Action", value: "text" },
            { label: "External Link", value: "web" },
          ],
          defaultValue: "text",
        },
        {
          control: "type",
          controlFunc: (doc, field) => field === "text",
          fold: [
            {
              label: "Button Payload",
              name: "payload",
              format: "select",
              selectStyle: "dropdown",
              selectRef: "intents",
              selectCap: "caption",
              selectVal: "_id",
              placeholder: "Intent",
              validate: ["required"],
              variant: "grid",
            },
          ],
        },
        {
          control: "type",
          controlFunc: (doc, field) => field === "web",
          fold: [
            {
              label: "URL",
              name: "payload",
              format: "text",
            },
          ],
        },
      ],
    },
  ],
};
const gptConfig: FormizoSchema[] = [
  {
    label: "Talk to GPT Virtual Assistant Settings",
    foldStyle: "outlined",
    defaultShow: true,
    collapse: [
      {
        label: "Enable Quick Reply Buttons",
        name: "talk2va.quick_reply.enabled",
        format: "bool",
        defaultValue: false,
      },
      quickReplyControl,
      {
        label: "Document base path",
        name: "doc_base_path",
        format: "text",
      },
    ],
  },
  // ...modelConfig,
];

const schema = {
  gptConig: gptConfig,
};

export default schema;
